import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import multimediaImageStyles from './image.scss.js';
import styles from './multimedia-promo.scss.js';
export class MultimediaPromo extends CipublicElement {
    constructor() {
        super(...arguments);
        this.background = 'primary';
        this.variant = 'basic';
        this.size = 'large';
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<div class="promo-${this.variant}-${this.size}"><slot name="image" @slotchange="${(event) => {
            addStyleSheetToElements(event.target.assignedElements(), multimediaImageStyles);
        }}"></slot><div class="content-container"><div class="content-wrapper"><slot name="accent"></slot><slot name="heading"></slot><slot></slot><slot name="multimedia-option"></slot></div></div></div>`;
    }
}
__decorate([
    property({ reflect: true })
], MultimediaPromo.prototype, "alt", void 0);
__decorate([
    property({ reflect: true })
], MultimediaPromo.prototype, "src", void 0);
__decorate([
    property({ reflect: true })
], MultimediaPromo.prototype, "background", void 0);
__decorate([
    property({ reflect: true })
], MultimediaPromo.prototype, "variant", void 0);
__decorate([
    property({ reflect: true })
], MultimediaPromo.prototype, "size", void 0);
//# sourceMappingURL=multimedia-promo.js.map